module.exports = __webpack_public_path__ + "img/p6_03.61b6f305.png";